// extracted by mini-css-extract-plugin
export default {"questionSold":"_56c5d1d","buttons":"_df90c122","requestPrice":"_c0948b7b","contactSellerButton":"_db100030"};